import { Action } from '@ngrx/store';

import { HideModalReason } from '®shared/modals';

export enum ArchiveListActionTypes {
  ARCHIVE_LIST_SHOW_MODAL = '[Archive list] Show modal',
  ARCHIVE_LIST_HIDE_MODAL = '[Archive list] Hide modal',
  ARCHIVE_LIST = '[Archive list] Archive list',
  ARCHIVE_LIST_SUCCEEDED = '[Archive list] Archive list succeeded',
  ARCHIVE_LIST_FAILED = '[Archive list] Archive list failed',
}

export interface ListIdPayload {
  listId: string;
}

export class ArchiveListShowModalAction implements Action {
  readonly type = ArchiveListActionTypes.ARCHIVE_LIST_SHOW_MODAL;

  constructor(public payload: ListIdPayload) {}
}

export interface ArchiveListHideModalPayload extends ListIdPayload {
  reason: HideModalReason;
}

export class ArchiveListHideModalAction implements Action {
  readonly type = ArchiveListActionTypes.ARCHIVE_LIST_HIDE_MODAL;

  constructor(public payload: ArchiveListHideModalPayload) {}
}

export class ArchiveListAction implements Action {
  readonly type = ArchiveListActionTypes.ARCHIVE_LIST;

  constructor(public payload: ListIdPayload) {}
}

export class ArchiveListSucceededAction implements Action {
  readonly type = ArchiveListActionTypes.ARCHIVE_LIST_SUCCEEDED;

  constructor(public payload: ListIdPayload) {}
}

export interface ArchiveListFailedPayload extends ListIdPayload {
  error: any;
}

export class ArchiveListFailedAction implements Action {
  readonly type = ArchiveListActionTypes.ARCHIVE_LIST_FAILED;

  constructor(public payload: ArchiveListFailedPayload) {}
}

export type ArchiveListActions =
  | ArchiveListShowModalAction
  | ArchiveListHideModalAction
  | ArchiveListAction
  | ArchiveListSucceededAction
  | ArchiveListFailedAction;
